export default __webpack_public_path__ + "static/arbitration-consent-b2391284c2bac94a68cae2f88f49eb54.pdf";